// TODO: See if this can be added to Operator Gateway
export enum SlateCodes {
  COMM = 'COMM',
  COMM_PRE_POST = 'COMM_PRE_POST',
  PSB = 'PSB',
  TYFW = 'TYFW',
  WEATHER = 'WEATHER',
}
